import { render } from "./audit-return.vue?vue&type=template&id=6bed7fcc&scoped=true&ts=true"
import script from "./audit-return.vue?vue&type=script&lang=tsx"
export * from "./audit-return.vue?vue&type=script&lang=tsx"

import "./audit-return.vue?vue&type=style&index=0&id=6bed7fcc&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bed7fcc"]])

export default __exports__